<div class="columns" *ngIf="imageTypes && imageTypes.size">
  <div
    *ngFor="let imageType of imageTypes; let i = index"
    class="column is-one-quarter"
  >
    <div class="gallery-item">
      <div class="gallery-item-actions buttons">
        <ng-container *ngIf="!isReadonly">
          <input
            #file
            type="file"
            (change)="
              upload.emit({ event: $event, imageTypeId: imageType.get('id') })
            "
          />
          <button
            type="button"
            style="padding: 6px; height: 30px !important"
            *ngIf="!hasImage(imageType.get('name'))"
            [disabled]="!editable"
            class="button is-small is-success"
            (click)="file.click()"
            translationEditableDirective="UPLOAD"
          >
            <svg
              width="17"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                d="M18 15V18H15V20H18V23H20V20H23V18H20V15H18M13.3 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V13.3C20.4 13.1 19.7 13 19 13C17.9 13 16.8 13.3 15.9 13.9L14.5 12L11 16.5L8.5 13.5L5 18H13.1C13 18.3 13 18.7 13 19C13 19.7 13.1 20.4 13.3 21Z"
              />
            </svg>
          </button>

          <alert
            #uploadAlert
            (confirm)="file.click()"
            titleTrnKey="ARE_YOU_SURE"
            textTrnKey="FILE_UPLOAD_ALERT_TEXT"
          />

          <button
            type="button"
            style="padding: 6px; height: 30px !important"
            *ngIf="hasImage(imageType.get('name'))"
            class="button is-small is-success"
            [disabled]="!editable"
            translationEditableDirective="UPLOAD"
            (click)="uploadAlert.fire()"
            translationEditableDirective="UPLOAD"
          >
            <svg
              width="17"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                d="M18 15V18H15V20H18V23H20V20H23V18H20V15H18M13.3 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V13.3C20.4 13.1 19.7 13 19 13C17.9 13 16.8 13.3 15.9 13.9L14.5 12L11 16.5L8.5 13.5L5 18H13.1C13 18.3 13 18.7 13 19C13 19.7 13.1 20.4 13.3 21Z"
              />
            </svg>
          </button>
          <alert
            #deleteAlert
            (confirm)="delete.emit({ type: imageType })"
            titleTrnKey="ARE_YOU_SURE"
            textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
          />

          <button
            style="padding: 6px; height: 30px !important"
            type="button"
            class="button is-small is-danger"
            (click)="deleteAlert.fire()"
            [disabled]="!hasImage(imageType.get('name')) || !editable"
            translationEditableDirective="DELETE"
          >
            <svg
              width="17"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z"
              />
            </svg>
          </button>
        </ng-container>
      </div>
      <img
        (click)="open(i, hasImage(imageType.get('name')))"
        backgroundOpacity="0.8"
        [src]="getImageUrl(imageType.get('name'))"
        width="100%"
        [ngClass]="[!hasImage(imageType.get('name')) ? 'disabled' : '']"
      />
      <span [translationEditableDirective]="imageType.get('title')">{{
        imageType.get('title') | translate
      }}</span>
    </div>
  </div>
</div>

<div
  *ngIf="imageTypes && imageTypes.size == 0"
  class="gallery-empty"
  translationEditableDirective="NO_IMAGES_TO_DISPLAY"
>
  {{ 'NO_IMAGES_TO_DISPLAY' | translate }}
</div>
